import { Container, Grid, Typography } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import "./homeComponentStyles/threegiftcard.css";
import BestSellerCard from "../../components/bestSellerCard"

const ThreeGiftCard = (props) => {
    const showGaming = useMediaQuery("(min-width:1200px)");
    const { title = "Featured", giftCardData, design, stylingClass, mbackgroundColor, fixSlideView = false } = props;

    return (
        <Container
            maxWidth="false"
            sx={{
                py: 0,
                height: "100%",

            }}
            disableGutters={true}
        >
            <Grid
                container
                className={showGaming ? stylingClass : ''}
                sx={{
                    ...design,
                    p: { xs: 0, sm: 2, md: 2, lg: "4vh 1vw .5vh" },
                    backgroundColor: mbackgroundColor || "white.main",
                    borderRadius: { xs: 0, sm: 3, md: "20px", xl: 5 },
                    height: "100%",

                }}
            >
                <Grid item xs={12} sx={{ mb: { xs: "10px", sm: "15px" } }}>
                    <Typography
                        variant="h2"
                        display="block"
                        sx={{
                            fontSize: { sm: "1.4rem", md: "1.4rem", lg: "16px", xl: '18px' },
                            fontWeight: 500,
                            textAlign: { xs: "center", sm: "left" },
                            textTransform: "capitalize",
                            color: {
                                sm: "textPrimary.main",
                                lg: fixSlideView ? "textPrimary.main" : "white.main"
                            },
                        }}>
                        {title}
                    </Typography>
                </Grid>

                <Grid container>
                    <Grid
                        item
                        xs={12}
                    >
                        <BestSellerCard giftCardData={giftCardData} fixSlideView={fixSlideView} />
                    </Grid>

                </Grid>
            </Grid >
        </Container >
    );
};

export default ThreeGiftCard;
